import React from 'react';
import { Sparkles } from 'lucide-react';

type InfoStateCardProps = {
  eyebrow?: string;
  title: string;
  description: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
};

export function InfoStateCard({
  eyebrow,
  title,
  description,
  icon,
  action,
}: InfoStateCardProps) {
  return (
    <div className="mx-auto w-full max-w-2xl rounded-[32px] border border-slate-200/80 bg-white/95 p-8 shadow-[0_30px_80px_-45px_rgba(15,23,42,0.45)] backdrop-blur sm:p-10">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-500/10 text-emerald-600">
        {icon ?? <Sparkles className="h-7 w-7" />}
      </div>
      {eyebrow && (
        <p className="mt-6 text-xs font-semibold uppercase tracking-[0.26em] text-emerald-600">
          {eyebrow}
        </p>
      )}
      <h2 className="mt-3 text-3xl font-semibold tracking-tight text-slate-950">{title}</h2>
      <p className="mt-4 text-base leading-7 text-slate-600">{description}</p>
      {action && <div className="mt-8 flex flex-wrap items-center gap-3">{action}</div>}
    </div>
  );
}
